import React, { ComponentType, FunctionComponent, ReactNode, useEffect } from 'react';
import { GetCallBreakpoint } from 'app/containers/call/CallBreakpoint';
import { CallVideosLayout } from 'app/components/call/CallVideos/CallVideosLayout';
import { makeSpinnerLoader } from 'app/components/common/SpinnerLoader';
import InContentVideosVisibility from 'app/containers/call/InContentVideosVisibility';
import { CallBar, CallTab } from 'app/models/ui/call/constants';
import { useScrollCtrl } from 'app/components/scroll/ScrollContext';
import { CallbackRef } from 'app/utils/react';
import { IOuterControlProps } from './CallVideos/CallVideosFull';

const LoadCallVideosFull = makeSpinnerLoader(() => import('app/components/call/CallVideos/CallVideosFull'));

interface IProps {
  wrap?: (x: ReactNode) => ReactNode;
  controls?: IOuterControlProps;
  disableFixedHeaderVideo?: boolean;
  flexSize?: boolean;
}

const InContentVideos: FunctionComponent<IProps> = (props) => (
  <GetCallBreakpoint>{({ tab, bar }) => (
    bar !== CallBar.None && (
      <LoadCallVideosFull width="50px">{({ default: CallVideosFull }) =>
        <LoadedInContentVideos
          tab={tab}
          bar={bar}
          CallVideosFull={CallVideosFull}
          {...props}
        />
      }</LoadCallVideosFull>
    )
  )}</GetCallBreakpoint>
);

interface IVideosProps {
  disable?: boolean;
  controls?: IOuterControlProps;
  layout?: CallVideosLayout;
  getRef?: CallbackRef;
}

interface ILoadedProps extends IProps {
  tab: CallTab;
  bar: CallBar;
  CallVideosFull: ComponentType<IVideosProps>;
}

const LoadedInContentVideos: FunctionComponent<ILoadedProps> = ({
  wrap = (x: ReactNode) => x,
  disableFixedHeaderVideo,
  flexSize,
  tab,
  bar,
  CallVideosFull,
  ...props
}) => {
  const scrollCtrl = useScrollCtrl();

  useEffect(() => {
    scrollCtrl.setVideoLazyLoaded();
  }, [scrollCtrl]);

  return (
    <InContentVideosVisibility minVisibleHeight={0.5}>{({ visible, ref }) => {
      const disable = !disableFixedHeaderVideo && (!visible || (bar === CallBar.Top && tab !== CallTab.Content));
      // Provide null if the video is not enabled, so wrap methods can choose what will be rendered.
      return wrap(
        <CallVideosFull
          disable={disable}
          getRef={ref}
          layout={flexSize ? CallVideosLayout.Flex : CallVideosLayout.Proportional}
          {...props}
        />,
      );
    }}</InContentVideosVisibility>
  );
};

export default InContentVideos;
